$(function() {
	var stickyBar = $('.sticky-aem .sticky-cta');
	var stickyComponent = $('.sticky-aem');
	if ( stickyComponent.length > 0 ) {
		document.addEventListener("scroll", function (e) {
			var windowWidth = window.innerWidth;
			var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			if ($(window).scrollTop() >= $(stickyComponent).offset().top + $(stickyComponent).outerHeight()) {
				$(stickyBar).addClass('active');
			} else {
				$(stickyBar).removeClass('active');
			}
		});
	}
});

